var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4437_8702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.752 10H6.25195C4.17695 10 2.50195 11.675 2.50195 13.75V18.75C2.50195 20.125 3.62695 21.25 5.00195 21.25H7.50195V23.75C7.50195 25.125 8.62695 26.25 10.002 26.25H20.002C21.377 26.25 22.502 25.125 22.502 23.75V21.25H25.002C26.377 21.25 27.502 20.125 27.502 18.75V13.75C27.502 11.675 25.827 10 23.752 10ZM18.752 23.75H11.252C10.5645 23.75 10.002 23.1875 10.002 22.5V17.5H20.002V22.5C20.002 23.1875 19.4395 23.75 18.752 23.75ZM23.752 15C23.0645 15 22.502 14.4375 22.502 13.75C22.502 13.0625 23.0645 12.5 23.752 12.5C24.4395 12.5 25.002 13.0625 25.002 13.75C25.002 14.4375 24.4395 15 23.752 15ZM21.252 3.75H8.75195C8.06445 3.75 7.50195 4.3125 7.50195 5V7.5C7.50195 8.1875 8.06445 8.75 8.75195 8.75H21.252C21.9395 8.75 22.502 8.1875 22.502 7.5V5C22.502 4.3125 21.9395 3.75 21.252 3.75Z",
    fill: "#4E7FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4437_8702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintBlue);
export default __webpack_public_path__ + "static/media/print-blue.dd9fa24e446f1c365ad68094c1c374df.svg";
export { ForwardRef as ReactComponent };